import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ttqPage } from '@/utils/tiktokPixel';
import { hasMarketingConsent } from '@/utils/consentState';

/**
 * Fires a TikTok Pixel page() call on every SPA route change.
 * Only runs when marketing consent has been granted.
 */
const TikTokPageViewTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (hasMarketingConsent()) {
      ttqPage();
    }
  }, [pathname]);

  return null;
};

export default TikTokPageViewTracker;
